import Message from '../components/mail/model/Message';
import Paging from '../components/mail/model/Paging';
import IStoreState from "../store/IStoreState";

const defaultState: IStoreState = {
  deleteMode: false,
  isDesc: true,
  messageList: [],
  paginationInfo: {} as Paging,
  releaseMode: false,
  selectedMessage: {} as Message,
  sortField: 'date',
};

export default defaultState;



// WEBPACK FOOTER //
// ./src/reducers/mailInitialState.ts